export default {
  primaryColor: '#1976d2',
  warningColor: '#e08731',
};
